module.exports = __webpack_public_path__ + "4bb510b0caf5f6849056dbce6596d865.png";